import { CaseReducer, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ExamTypeModel } from 'data/exam/exam.model';

type SliceState = {
  status: 'idle' | 'loading' | 'data' | 'error';
  data: ExamTypeModel[];
  error: any;
};

const initState: SliceState = {
  status: 'idle',
  data: [],
  error: false,
};

const setLoading = (): SliceState => ({ ...initState, status: 'loading' });

const setData: CaseReducer<SliceState, PayloadAction<ExamTypeModel[]>> = (_, action) => ({
  error: false,
  data: action.payload,
  status: 'data',
});

const setError: CaseReducer<SliceState, PayloadAction<any>> = (state, action) => ({
  error: action.payload,
  data: [],
  status: 'error',
});

const examTypeSlice = createSlice({
  name: 'examType',
  initialState: initState,
  reducers: {
    setLoading,
    setData,
    setError,
  },
});

export default examTypeSlice;
